export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-v1-960-0e9f264ff3e55bb127e6585c25fde0f1.png";